<div class="table-padding">
  Concurso(s) em que o examinador faz parte da comissão julgadora:
  <table mat-table [dataSource]="filteredConcursosProvasData">

    <ng-container matColumnDef="nomeConcurso">
      <th mat-header-cell *matHeaderCellDef>Concurso</th>
      <td mat-cell *matCellDef="let element"> {{ element.nomeConcurso }} </td>
    </ng-container>

    <ng-container matColumnDef="papelExaminador">
      <th mat-header-cell *matHeaderCellDef>Papel</th>
      <td mat-cell *matCellDef="let element"> {{ element.papelExaminador }} </td>
    </ng-container>

    <ng-container matColumnDef="data1fase">
      <th mat-header-cell *matHeaderCellDef>Data da 1ª Prova da Fase 1</th>
      <td mat-cell *matCellDef="let element"> {{ element.data1fase | date:'dd/MM/yyyy' }} </td>
    </ng-container>

    <ng-container matColumnDef="data2fase">
      <th mat-header-cell *matHeaderCellDef>Data da 1ª Prova da Fase 2</th>
      <td mat-cell *matCellDef="let element"> {{ element.data2fase | date:'dd/MM/yyyy' }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['nomeConcurso', 'papelExaminador', 'data1fase', 'data2fase']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['nomeConcurso', 'papelExaminador', 'data1fase', 'data2fase']"></tr>
  </table>
</div>
